export default __webpack_public_path__ + "img/spring.bbfaa6d5.jpg";